import React from "react";
import { Download, Printer } from "lucide-react";
import { BACKEND } from "../lib/api";

/**
 * CsvButton - links to a backend CSV endpoint, including filter query string.
 * Path should start with "/" (e.g. "/reports/companies.csv").
 */
export function CsvButton({ path, params = {}, label = "Excel", testId = "btn-csv" }) {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  ).toString();
  const href = `${BACKEND}/api${path}${qs ? `?${qs}` : ""}`;
  return (
    <a href={href}
       className="cesco-btn-ghost text-xs flex items-center gap-1"
       target="_blank" rel="noreferrer"
       data-testid={testId}>
      <Download size={14}/> {label}
    </a>
  );
}

/**
 * PrintButton - triggers window.print(). Page must mark its data table with
 * `className="print-region"` for the @media print stylesheet to do its work.
 */
export function PrintButton({ label = "Print", testId = "btn-print" }) {
  return (
    <button type="button"
      onClick={() => window.print()}
      className="cesco-btn-ghost text-xs flex items-center gap-1"
      data-testid={testId}>
      <Printer size={14}/> {label}
    </button>
  );
}
